import { withTranslation } from '@modules/i18n_and_l10n/with_translation';
import { AnalyticAction } from '@application/analytic/analytic.service';
import { LicenceHolderService } from '@services/licence_holder.service';
import { useService } from '@visiba/instantiation';
import { useSelectedEntrance } from '../../../application/use_selected_entrance';
import { Item } from '../_item.component';

interface Props {
	__TEMP__navigate?: (url: string) => void;
	trackEvent(event: AnalyticAction): void;
}

export function LinkReceptionPicker({ trackEvent, __TEMP__navigate }: Props): JSX.Element {
	const licenceHolderService = useService(LicenceHolderService);
	const [entrance] = useSelectedEntrance();

	function handleClick(): void {
		trackEvent('Clicked: Reception-tab');
	}

	return (
		<Item
			to={`/${entrance?.route ?? `${licenceHolderService.alias}/change-unit`}`}
			icon='units'
			iconActive='units_filled'
			label={entrance?.name || withTranslation('PW.Component.Header.Picker.Reception.Label')}
			data-testid='header_link_units'
			__TEMP__navigate={__TEMP__navigate}
			onClick={handleClick}
		/>
	);
}
